import React, { useEffect, useLayoutEffect, useState } from 'react';
import { HeaderStyles } from './HeaderStyles';
import Logo from '../../assets/icons/Logo';
import { Link, useLocation, useNavigate } from 'react-router-dom';
import Menu from '../menu/Menu';
import { navigationData } from '../../constants';
import { useAppDispatch, useAppSelector } from '../../state/hooks';
import { useDispatch } from 'react-redux';
import { setInterfaceLanguage } from '../../state/slices/languageSlice';
import { InView } from 'react-intersection-observer';
import getTranslationByLangOrUk from '../../utils/getTranslationByLangOrUk';
import { translations } from '../../i18n/translations';

const availableLanguages = [
  {
    name: 'UA',
    value: 'uk',
  },
  {
    name: 'RU',
    value: 'ru',
  },
  {
    name: 'EN',
    value: 'en',
  },
];

function Header() {
  const [menuOpen, setMenuOpen] = useState<boolean>(false);

  const { interfaceLanguage } = useAppSelector((state) => state.languages);
  const [activeLanguageIndex, setActiveLanguageIndex] = useState<number>(0);
  const { pathname } = useLocation();
  const navigate = useNavigate();
  const dispatch = useAppDispatch();

  useEffect(() => {
    if (availableLanguages[activeLanguageIndex].value !== interfaceLanguage) {
      setActiveLanguageIndex(availableLanguages.findIndex((lang) => interfaceLanguage === lang.value));
    }
  }, [interfaceLanguage]);

  return (
    <HeaderStyles>
      <InView as="div" className="contentWrapper" onChange={(inView, entry) => (inView ? entry.target.classList.add('active') : '')}>
        <Menu
          active={menuOpen}
          handleMenu={() => setMenuOpen(!menuOpen)}
          setActive={() => setMenuOpen(false)}
        />

        <div className="container">
          <Link className="logo" to="/">
            <Logo />
          </Link>

          <div className="menuWrapper">
            <button
              type="button"
              className="langButton"
              onClick={() => {
                if (activeLanguageIndex < availableLanguages.length - 1) {
                  localStorage.setItem('interfaceLanguageRealistSecurityHub', availableLanguages[activeLanguageIndex + 1].value);
                  // @ts-ignore
                  dispatch(setInterfaceLanguage(availableLanguages[activeLanguageIndex + 1].value));
                  setActiveLanguageIndex((value) => value + 1);
                  navigate(`/${availableLanguages[activeLanguageIndex + 1].value}/${pathname.split('/').slice(2).join('/')}`);
                } else {
                  localStorage.setItem('interfaceLanguageRealistSecurityHub', availableLanguages[0].value);
                  // @ts-ignore
                  dispatch(setInterfaceLanguage(availableLanguages[0].value));
                  setActiveLanguageIndex(0);
                  navigate(`/${availableLanguages[0].value}/${pathname.split('/').slice(2).join('/')}`);
                }

                // if (interfaceLanguage === 'uk') {
                //   localStorage.setItem('interfaceLanguageRealistSecurityHub', 'ru');
                //   dispatch(setInterfaceLanguage('ru'));
                //   navigate(`/ru/${pathname.split('/').slice(2).join('/')}`);
                // } else if (interfaceLanguage === 'ru') {
                //   localStorage.setItem('interfaceLanguageRealistSecurityHub', 'uk');
                //   dispatch(setInterfaceLanguage('ru'));
                //   navigate(`/uk/${pathname.split('/').slice(2).join('/')}`);
                // }
              }}
            >
              {availableLanguages[activeLanguageIndex].name}
            </button>

            <div className="splitter" />

            <ul>
              {navigationData(interfaceLanguage).map((item) => <li key={item.path}><Link to={`/${interfaceLanguage}${item.path}`}>{item.name}</Link></li>)}
            </ul>

            {/* eslint-disable-next-line jsx-a11y/control-has-associated-label */}
            <button className={menuOpen ? 'menuButton' : 'menuButton active'} type="button" onClick={() => setMenuOpen(true)}>
              <div />
              <div />
              <div />
            </button>
          </div>
        </div>
      </InView>
    </HeaderStyles>
  );
}

export default Header;
